import { Observable, throwError } from 'rxjs';
import { Injectable } from '@angular/core';
import { Request } from './request.model';
import { ModelService } from '../../../shared/services/model.service';
import * as _ from 'lodash';
import { catchError, map } from 'rxjs/operators';
import { HttpParams } from '@angular/common/http';
import { ApiHttpClient } from 'app/http/clients/api';

export interface ManySaveResponse {
    success: boolean;
    data: Request[];
    errors: {
        message: string;
        code: any;
        key: string;
    }[];
}

@Injectable()
export class RequestService extends ModelService<Request> {
    protected urlPath = '/request';

    constructor(http: ApiHttpClient) {
        super(http);
    }

    createMany(models: Request[], borrowerId: number): Observable<Request[]> {
        const requestsJson = models.map((model) => model.json());
        const requests$ = this.http.post<any[]>(this.postUrl(models[0]), {
            borrowerId,
            requests: requestsJson
        });

        return requests$.pipe(
            map((requests) => requests.map(this.createFromResponseData))
        );
    }

    updateMany(models: Request[], borrowerId: number): Observable<Request[]> {
        const requestsJson = models.reduce((collection: Object[], model: Request) => {
            collection.push(model.json());
            return collection;
        }, []);

        const requests$ = this.http.put(this.endpointUrl, { borrowerId, requests: requestsJson });

        return requests$.pipe(
            map((requests: any[]) => requests.map(this.createFromResponseData)),
            catchError((errors) => {
                models.forEach((model, i) => {
                    model.errors = errors[i];
                });
                return throwError(() => errors);
            })
        );
    }

    forBorrower(borrowerId: number): Observable<any> {
        return this.getAll({
            query: {
                criteria: {
                    borrowerId: { '==': borrowerId }
                }
            }
        });
    }

    getAll(params = {}): Observable<Request[]> {
        return this.httpGetAllResponse(params).pipe(
            map(body => body.map((modelInstanceValues) => this.createFromResponseData(modelInstanceValues)))
        );
    }

    protected createFromResponseData(responseData: any): Request {
        return new Request(responseData);
    }

    protected httpGetAllResponse(params): Observable<any> {
        // Search.php middleware expects "query" input
        if (params.query) {
            params = Object.assign({}, params, {
                query: JSON.stringify(params.query)
            });
        }
        return this.http.get(this.endpointUrl + '/lender', {
            params: this.httpParams(params)
        });
    }

    protected httpParams(params): HttpParams {
        let httpParams = new HttpParams();
        for (const key in params) {
            if (params.hasOwnProperty(key)) {
                httpParams = httpParams.set(key, params[key]);
            }
        }
        return httpParams;
    }

}
